import React from "react";

import "./StatCard.css";

export interface StatCardProps {
  title: string;
  value: string | number;
  iconClassName?: string;
  deltaText?: string;
  deltaTone?: "positive" | "negative" | "neutral";
  valueTone?: "default" | "danger" | "success";
  iconBgColor?: string;
  iconColor?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  iconClassName,
  deltaText,
  deltaTone = "neutral",
  valueTone = "default",
  iconBgColor,
  iconColor,
}) => {
  const arrowIcon =
    deltaTone === "positive"
      ? "ph-trend-up"
      : deltaTone === "negative"
        ? "ph-trend-down"
        : null;

  const valueClass = [
    "ads-stat-card__value",
    valueTone === "danger" ? "ads-stat-card__value--danger" : "",
    valueTone === "success" ? "ads-stat-card__value--success" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className="ads-stat-card">
      <div className="ads-stat-card__left">
        <div className="ads-stat-card__title">{title}</div>
        <div className={valueClass}>{value}</div>
        {deltaText && (
          <div
            className={[
              "ads-stat-card__delta",
              deltaTone === "positive"
                ? "ads-stat-card__delta--positive"
                : deltaTone === "negative"
                  ? "ads-stat-card__delta--negative"
                  : "ads-stat-card__delta--neutral",
            ].join(" ")}
          >
            {arrowIcon && <i className={`${arrowIcon} ads-stat-card__delta-arrow`} aria-hidden="true" />}
            {deltaText}
          </div>
        )}
      </div>
      {iconClassName && (
        <div
          className="ads-stat-card__icon-box"
          style={iconBgColor ? { background: iconBgColor } : undefined}
        >
          <i
            className={`${iconClassName} ads-stat-card__icon`}
            aria-hidden="true"
            style={iconColor ? { color: iconColor } : undefined}
          />
        </div>
      )}
    </div>
  );
};
